import { render } from "./GoogleBasicBarChart.vue?vue&type=template&id=0f29fb22"
import script from "./GoogleBasicBarChart.vue?vue&type=script&lang=js"
export * from "./GoogleBasicBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/builds/conurse/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__